import { UserPosition } from './../../models/user.model';
import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { Observable } from 'rxjs/Observable';
import { GeoEvent } from './../../models/geo.model';
import { Geolocation } from '@ionic-native/geolocation';
import { Platform } from 'ionic-angular';

declare var window;
@Injectable()
export class GeoFenceProvider {

  constructor(public api: Api, private geolocation: Geolocation, private platform: Platform) {}

  sendPositionInterval: any;
  userLocation: UserPosition = new UserPosition();
  events = [];
  locationsWatchList = [];
  singlePosition: number;
  watchig: boolean = false;
  lastPositionTimeStamp = new Date().getTime();
  timeDIfference = 0;
  locationSub: any;

  sendLocation(location: UserPosition): Observable<any> {
    return this.api.post('geo/position', location).map(res => {
      return res;
    });
  }

  loadNearByEvents(): Observable<any> {
    return this.api.post('loadNearByEvents', {});
  }

  eventStatus(body: GeoEvent): Observable<any> {
    return this.api.post('geo/fence', body);
  }

  watchAndSend(): void {
    this.platform.ready().then(() => {
    this.readAndSendLocation();
    // if (navigator.geolocation) {
      if (!this.watchig) {
        this.watchig = true;

        this.locationSub = this.geolocation.watchPosition()
          .filter((p) => p.coords !== undefined) //Filter Out Errors;
          .subscribe(
            (position) => {
              let currentDate = new Date().getTime();
              let timediff = currentDate - this.lastPositionTimeStamp;

              console.log('WATCHING POSITION', position.coords.latitude);

              if (timediff >= this.timeDIfference) {
                this.lastPositionTimeStamp = currentDate;
                this.setUserLocation(position);
              }
            }
          );
      }
    });
  }

  readAndSendLocation(lowAcc?: boolean) {

    const options = {
      enableHighAccuracy: lowAcc ? false : true,
      timeout: 10000,
      maximumAge: 0
    }

    // this.geolocation.getCurrentPosition(options)
    // .then((position) => {
    //     this.setUserLocation(position);
    // }).catch((error) => {
    //     console.log('Error getting location', error);
    //     console.log(JSON.stringify(error, null, 2));
    //     if (!lowAcc) {
    //       console.log('readAndSendLocation error fired', error);
    //       this.readAndSendLocation(true);
    //     }
    // });
  }

  getCurrentPosition() {
    const options = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 60000
    }

    return this.geolocation.getCurrentPosition(options).then((resp) => {
      return resp.coords;
     }).catch((error) => {
       console.log('Error getting location', error);
       return null;
     });
  }

  setUserLocation(position: any) {
    console.log('This is position', position);
    this.userLocation.lat = position.coords.latitude;
    this.userLocation.lon = position.coords.longitude;
    this.sendLocation(this.userLocation).subscribe(
      res => {
        this.timeDIfference = res.timeDiffInMs;
      },
      err => {
        console.log('LOCATION SENT ERROR: ', err)
      }
    );
  }

  clearWatch() {
    if (this.locationSub) {
      this.locationSub.unsubscribe();
      this.locationSub = null;
    }
  }

  //This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
  isInRadius(eventCoord, userCoord) {
    // var R = 6.371; // km
    var R = 6371000;
    var dLat = this.toRad(userCoord.lat - eventCoord.lat);
    var dLon = this.toRad(userCoord.lon - eventCoord.lon);
    var lat1 = this.toRad(eventCoord.lat);
    var lat2 = this.toRad(userCoord.lat);

    var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    var d = R * c;
    return d;
  }

  // Converts numeric degrees to radians
  toRad(value) {
      return value * Math.PI / 180;
  }

}



// WEBPACK FOOTER //
// ./src/providers/geo-fence/geo-fence.ts